import angular from "angular";

angular
    .module('app')
    .component('taskAnswer', {
        template: require('./task-answer.html'),
        controller: ['Upload', '$uibModal', '$http', 'Notifier', '$window', 'trans', controller],
        bindings: {
            course: '<',
            lesson: '<',
            answer: '<',
            courseStatus: '<',
        }
    });

function controller(Upload, $uibModal, $http, Notifier, $window, trans) {


    let $ctrl = this;

    $ctrl.answerText = null;
    $ctrl.answerFiles = [];

    $ctrl.description = null;
    $ctrl.enableTask = null;
    $ctrl.help = null;

    $ctrl.$onInit = function () {
        $ctrl.description = $ctrl.lesson.task ? $ctrl.lesson.task.description : null;
        $ctrl.enableTask = $ctrl.lesson.task ? $ctrl.lesson.task.enabled : null;
        $ctrl.help = $ctrl.lesson.task ? $ctrl.lesson.task.help : null;
    };


    $ctrl.openUserAnswer = function () {
        $uibModal
            .open({
                component: 'userAnswerModal',
                keyboard: false,
                backdrop: true,
                resolve: {
                    answer: function () {
                        return $ctrl.answer;
                    }
                }
            })
            .result
            .then(
                function (result) {

                }
            );
    };

    $ctrl.setAnswer = function () {

        if (!$ctrl.answerText) {
            $ctrl.answerText = 'Үй тапсырмасы.';
            // window.Swal.fire({
            //     icon: 'error',
            //     title: 'Үй тапсырмасы толтырылмаған',
            // });
            // return;
        }

        $ctrl.loading = true;

        let params = {
            answer_text: $ctrl.answerText || undefined,
            answer_files: $ctrl.answerFiles,
        };

        Upload
            .upload({
                url: `/cabinet/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/set-answer`,
                data: params
            })
            .then(
                function (response) {
                    $ctrl.answer = response.data.answer;
                    $ctrl.loading = false;
                    window.Swal.fire({
                        icon: 'success',
                        title: trans('Reply sent successfully'),
                        showConfirmButton: true,
                    });
                },
                function (error) {
                    $ctrl.loading = false;
                    window.Swal.fire({
                        icon: 'error',
                        title: trans('An error has occurred'),
                        showConfirmButton: true,
                    });
                }
            );
    }

    $ctrl.openImage = function (file) {
        window.open(file.url);
    }

}
